var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdexLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1152,
    height: 286,
    viewBox: "0 0 1152 286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M376 41H440V245H376V41Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.15 41.2591H932.579L1007.5 143.13L932.579 245H1002.15L1042.29 190.427L1082.43 245H1152L1077.08 143.13L1152 41.2591H1082.43L1042.29 95.8326L1002.15 41.2591Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M772.529 41H719V202.053C719 225.772 738.173 245 761.824 245H772.529H783.235H901V191.316H783.235V169.842H860.882V116.158H783.235V94.6842H901V41H783.235H772.529Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M534.966 41H483V245H534.966H547H582.966C639.299 245 684.966 199.333 684.966 143C684.966 86.667 639.299 41 582.966 41H547H534.966ZM547 96V190H582.966C608.923 190 629.966 168.957 629.966 143C629.966 117.043 608.923 96 582.966 96H547Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 245.143L4.96528 251.527L31.7778 286H244.094H254.222L286 245.143L206.556 143L281.035 47.2411L286 40.8571L254.222 0H31.7778L26.7139 6.5108L0 40.8571L79.4444 143L0 245.143ZM95.8016 224.714C89.1444 224.714 85.3996 217.058 89.4867 211.803L111.222 183.857L143 224.714H95.8016ZM201.492 136.489L270.907 47.2411H142.3C138.139 47.2411 135.798 52.0265 138.353 55.3108L143 61.2857H190.198C196.856 61.2857 200.6 68.9424 196.513 74.1972L174.778 102.143L201.492 136.489ZM10.1278 40.8571L166.582 242.013L167.706 243.457C170.26 246.741 167.92 251.527 163.759 251.527H158.889H15.0931L36.9403 279.616H239.129L31.7778 13.0214L10.1278 40.8571Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdexLogoWhite);
export default __webpack_public_path__ + "static/media/IDEX-logo-white.e1675f5d8d1dabaf0fa18985f812cdb7.svg";
export { ForwardRef as ReactComponent };